/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LinearGradientIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Linear Gradient',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path opacity=".9" d="M4 32v-2h28v2z" />
    <path opacity=".8" d="M4 30v-2h28v2z" />
    <path opacity=".7" d="M4 28v-2h28v2z" />
    <path opacity=".6" d="M4 26v-2h28v2z" />
    <path opacity=".5" d="M4 24v-2h28v2z" />
    <path opacity=".4" d="M4 22v-2h28v2z" />
    <path opacity=".25" d="M4 16v-2h28v2z" />
    <path opacity=".3" d="M4 18v-2h28v2z" />
    <path opacity=".35" d="M4 20v-2h28v2z" />
    <path opacity=".2" d="M4 14v-2h28v2z" />
    <path opacity=".15" d="M4 12v-2h28v2z" />
    <path opacity=".1" d="M4 10V8h28v2z" />
    <path opacity=".05" d="M4 8V6h28v2z" />
    <path
      d="M3 34h30a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1ZM32 4v28H4V4Z"
    />
  </svg>`;
};
